<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="true"
        :is-full-page="true"
    ></b-loading>
    <b-modal v-model="modalActive" width="90%" scroll="clip" style="z-index: 101" @close="clearFields()">
      <div class="modal-card" style="width: auto;">
        <header class="modal-card-head" style="padding: 12px">
          <h6 class="is-size-5 ml-auto mr-auto pl-4 has-text-weight-semibold">Edit Crossing Type</h6>
          <button
              type="button"
              class="delete"
              @click="show(false, '', deselectOnClose)"/>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <div
                v-for="(group, groupLabel) in crossingTypes"
                :key="groupLabel"
                class="box mb-4">
              <h6 class="has-text-weight-semibold mb-2">
                {{ groupLabel }}
              </h6>

              <div v-if="isObject(group)">
                <b-radio
                    v-for="(value, label) in group"
                    :key="value"
                    v-model="crossingType"
                    :native-value="value"
                    class="mb-2">
                  {{ label }}
                </b-radio>
              </div>

              <div v-else>
                <b-radio
                    v-model="crossingType"
                    :native-value="group">
                  {{ groupLabel }}
                </b-radio>
              </div>

            </div>

          </div>
        </section>

        <footer class="modal-card-foot" style="padding: 0">
          <b-button class="is-primary is-fullwidth m-2" @click="onUpdateDevice" rounded>
            UPDATE DEVICE
          </b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {CrossingTypes} from "@/utils/utils";

export default {
  name: "edit-crossing-type",
  data() {
    return {
      isLoading: false,
      modalActive: false,
      deselectOnClose: false,
      device: null,

      crossingTypes: CrossingTypes,
      crossingType: null,
    }
  },

  methods: {
    ...mapActions({
      updateCrossingType: 'projectsModule/updateCrossingType'
    }),

    isObject(val) {
      return val !== null && typeof val === 'object'
    },

    show(show, deselectOnClose, device) {
      this.modalActive = show
      this.deselectOnClose = deselectOnClose

      if (!show) {
        this.clearFields()
        return
      }

      setTimeout(() => {
        this.device = device
        this.crossingType = device?.crossingType || null
      }, 300)
    },

    async onUpdateDevice() {
      if (!this.crossingType) {
        this.showToast('Please select crossing type', 'is-warning')
        return
      }

      const payload = {
        id: this.device._id,
        crossingType: this.crossingType
      }

      this.isLoading = true

      const response = await this.updateCrossingType(payload)

      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
      } else {
        this.showToast('Crossing Type successfully updated', 'is-success')
        this.show(false)
      }

      this.isLoading = false
    },

    clearFields() {
      this.device = null
      this.crossingType = null
    },

    showToast(message, type) {
      this.$buefy.toast.open({
        message,
        type,
        duration: 3000
      })
    }
  },
}
</script>

<style scoped>

</style>